var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner",class:{'has-image': !!_vm.imageVersions.length}},[(!!_vm.imageVersions.length)?_c('ResponsiveImage',{staticClass:"background",attrs:{"image-versions":_vm.imageVersions,"width":_vm.width,"egar":true}}):_vm._e(),_c('div',{staticClass:"words"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }